import React, { useState } from "react";
import Modal from "../../components/common/Modal";

const Assignments = () => {
    const [tableSearch, setTableSearch] = useState("");

    const initialAssignments = [
        { id: 1, curriculum: "CBSE", class: "8th", section: "A", subject: "Maths", title: "Algebra Homework", date: "2026-06-10", submission: "2026-06-15", description: "Solve exercise 5", send: "All", students: 40 },
        { id: 2, curriculum: "ICSE", class: "9th", section: "B", subject: "Science", title: "Physics Assignment", date: "2026-06-12", submission: "2026-06-20", description: "Chapter 2 questions", send: "All", students: 35 }
    ];

    const [assignments, setAssignments] = useState(initialAssignments);

    const [filters, setFilters] = useState({
        curriculum: "", class: "", section: "", subject: "", fromDate: "", toDate: "",
    });

    const [dateFilter, setDateFilter] = useState({ fromDate: "", toDate: "" });
    const [showModal, setShowModal] = useState(false);
    const [editingId, setEditingId] = useState(null);

    const emptyForm = {
        curriculum: "", class: "", section: "", subject: "", send: "All",
        title: "", description: "", file: null, date: "", submission: "",
    };

    const [formData, setFormData] = useState(emptyForm);

    const curriculumOptions = ["CBSE", "ICSE", "State Board", "IB", "IGCSE"];

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    const handleFilter = () => {
        setDateFilter({ fromDate: filters.fromDate, toDate: filters.toDate });
    };

    const handleFormChange = (e) => {
        const { name, value, files } = e.target;
        setFormData(prev => ({ ...prev, [name]: files ? files[0] : value }));
    };

    const handleOpenAdd = () => {
        setEditingId(null);
        setFormData(emptyForm);
        setShowModal(true);
    };

    const handleEdit = (item) => {
        setEditingId(item.id);
        setFormData({
            curriculum: item.curriculum,
            class: item.class,
            section: item.section,
            subject: item.subject,
            send: item.send,
            title: item.title,
            description: item.description,
            file: null,
            date: item.date,
            submission: item.submission,
        });
        setShowModal(true);
    };

    const handleDelete = (id) => {
        setAssignments(prev => prev.filter(item => item.id !== id));
    };

    const handleSubmit = () => {
        if (!formData.curriculum || !formData.class || !formData.section || !formData.subject || !formData.title) {
            alert("Please fill in Curriculum, Class, Section, Subject, and Assignment Title.");
            return;
        }

        if (editingId !== null) {
            setAssignments(prev =>
                prev.map(item =>
                    item.id === editingId
                        ? { ...item, ...formData }
                        : item
                )
            );
        } else {
            setAssignments(prev => [
                ...prev,
                { id: Date.now(), ...formData, students: 0 }
            ]);
        }

        setFormData(emptyForm);
        setEditingId(null);
        setShowModal(false);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setEditingId(null);
        setFormData(emptyForm);
    };

    const data = assignments.filter(item => {
        const itemDate = new Date(item.date);
        const from = dateFilter.fromDate ? new Date(dateFilter.fromDate) : null;
        const to   = dateFilter.toDate   ? new Date(dateFilter.toDate)   : null;
        return (
            (!tableSearch || JSON.stringify(item).toLowerCase().includes(tableSearch.toLowerCase()))
            && (!filters.curriculum || item.curriculum === filters.curriculum)
            && (!filters.class      || item.class      === filters.class)
            && (!filters.section    || item.section    === filters.section)
            && (!filters.subject    || item.subject    === filters.subject)
            && (!from || itemDate >= from)
            && (!to   || itemDate <= to)
        );
    });

    const ModalForm = (
        <>
            {/* Row 1: Curriculum, Class, Section, Subject */}
            <div className="row mb-3">
                <div className="col-md-3">
                    <label className="form-label">Curriculum</label>
                    <select className="form-select" name="curriculum" value={formData.curriculum} onChange={handleFormChange}>
                        <option value="">Select Curriculum</option>
                        {curriculumOptions.map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                </div>
                <div className="col-md-3">
                    <label className="form-label">Class</label>
                    <select className="form-select" name="class" value={formData.class} onChange={handleFormChange}>
                        <option value="">Select Class</option>
                        <option value="8th">8th</option>
                        <option value="9th">9th</option>
                    </select>
                </div>
                <div className="col-md-3">
                    <label className="form-label">Section</label>
                    <select className="form-select" name="section" value={formData.section} onChange={handleFormChange}>
                        <option value="">Select Section</option>
                        <option value="A">A</option>
                        <option value="B">B</option>
                    </select>
                </div>
                <div className="col-md-3">
                    <label className="form-label">Subject</label>
                    <select className="form-select" name="subject" value={formData.subject} onChange={handleFormChange}>
                        <option value="">Select Subject</option>
                        <option value="Maths">Maths</option>
                        <option value="Science">Science</option>
                        <option value="English">English</option>
                    </select>
                </div>
            </div>

            {/* Row 2: Assignment Send */}
            <div className="mb-3">
                <label className="form-label">Assignment Send</label>
                <div className="d-flex gap-4">
                    <div className="form-check">
                        <input className="form-check-input" type="radio" name="send" id="sendAll" value="All"
                            checked={formData.send === "All"} onChange={handleFormChange} />
                        <label className="form-check-label" htmlFor="sendAll">All</label>
                    </div>
                    <div className="form-check">
                        <input className="form-check-input" type="radio" name="send" id="sendIndividual" value="Individual"
                            checked={formData.send === "Individual"} onChange={handleFormChange} />
                        <label className="form-check-label" htmlFor="sendIndividual">Individual</label>
                    </div>
                </div>
            </div>

            {/* Row 3: Title */}
            <div className="mb-3">
                <label className="form-label">Assignment Title</label>
                <input type="text" className="form-control" name="title" value={formData.title} onChange={handleFormChange} />
            </div>

            {/* Row 4: Description */}
            <div className="mb-3">
                <label className="form-label">Description</label>
                <textarea className="form-control" name="description" rows={4} value={formData.description} onChange={handleFormChange} />
            </div>

            {/* Row 5: File, Start Date, Submission Date */}
            <div className="row mb-4">
                <div className="col-md-4">
                    <label className="form-label">Assignment File</label>
                    <input type="file" className="form-control" name="file" onChange={handleFormChange} />
                </div>
                <div className="col-md-4">
                    <label className="form-label">Start Date</label>
                    <input type="date" className="form-control" name="date" value={formData.date} onChange={handleFormChange} />
                </div>
                <div className="col-md-4">
                    <label className="form-label">Submission Date</label>
                    <input type="date" className="form-control" name="submission" value={formData.submission} onChange={handleFormChange} />
                </div>
            </div>

            <button
                className="btn text-white"
                style={{ backgroundColor: "#20c997" }}
                onClick={handleSubmit}
            >
                {editingId !== null ? "Update" : "Submit"}
            </button>
        </>
    );

    return (
        <div className="">
            {/* FILTER SECTION */}
            <div className="card border-0">
                <div className="card-header d-inline">
                    <div className="row align-items-end">
                        <div className="col-md-2">
                            <label className="form-label">Curriculum</label>
                            <select className="form-select" name="curriculum" value={filters.curriculum} onChange={handleFilterChange}>
                                <option value="">Select Curriculum</option>
                                {curriculumOptions.map(c => <option key={c} value={c}>{c}</option>)}
                            </select>
                        </div>
                        <div className="col-md-2">
                            <label className="form-label">Class</label>
                            <select className="form-select" name="class" value={filters.class} onChange={handleFilterChange}>
                                <option value="">Select Class</option>
                                <option value="8th">8th</option>
                                <option value="9th">9th</option>
                            </select>
                        </div>
                        <div className="col-md-2">
                            <label className="form-label">Section</label>
                            <select className="form-select" name="section" value={filters.section} onChange={handleFilterChange}>
                                <option value="">Select Section</option>
                                <option value="A">A</option>
                                <option value="B">B</option>
                            </select>
                        </div>
                        <div className="col-md-2">
                            <label className="form-label">Subject</label>
                            <select className="form-select" name="subject" value={filters.subject} onChange={handleFilterChange}>
                                <option value="">Select Subject</option>
                                <option value="Maths">Maths</option>
                                <option value="Science">Science</option>
                            </select>
                        </div>
                        <div className="col-md-2">
                            <label className="form-label">From Date</label>
                            <input type="date" name="fromDate" className="form-control" value={filters.fromDate} onChange={handleFilterChange} />
                        </div>
                        <div className="col-md-2">
                            <label className="form-label">To Date</label>
                            <input type="date" name="toDate" className="form-control" value={filters.toDate} onChange={handleFilterChange} />
                        </div>
                        {/* <div className="col-md-2">
                            <button className="btn btn-primary text-white w-100" onClick={handleFilter}>Search</button>
                        </div> */}
                    </div>
                </div>
            </div>

            {/* TABLE */}
            <div className="card border-0 shadow-sm">
                <div className="card-header bg-white d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">List Of Assignments</h5>
                    <button className="btn btn-add" onClick={handleOpenAdd}>+ Add Assignment</button>
                </div>
                <div className="card-body">
                    <div className="row mb-3">
                        <div className="col-md-2">
                            <select className="form-select"><option>10</option></select>
                        </div>
                        <div className="col-md-4 ms-auto">
                            <input className="form-control" placeholder="Search..." value={tableSearch}
                                onChange={(e) => setTableSearch(e.target.value)} />
                        </div>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-bordered align-middle">
                            <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Curriculum</th>
                                    <th>Class</th>
                                    <th>Section</th>
                                    <th>Subject</th>
                                    <th>Assignment Title</th>
                                    <th>Date</th>
                                    <th>Submission Date</th>
                                    <th>Description</th>
                                    <th>Send Option</th>
                                    <th>Students</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.length ? data.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{index + 1}</td>
                                        <td>{item.curriculum}</td>
                                        <td>{item.class}</td>
                                        <td>{item.section}</td>
                                        <td>{item.subject}</td>
                                        <td>{item.title}</td>
                                        <td>{item.date}</td>
                                        <td>{item.submission}</td>
                                        <td>{item.description}</td>
                                        <td>{item.send}</td>
                                        <td>{item.students}</td>
                                        <td>
                                            <div className="d-flex gap-2">
                                                <button className="btn btn-sm btn-primary" onClick={() => handleEdit(item)}>Edit</button>
                                                <button className="btn btn-sm btn-danger" onClick={() => handleDelete(item.id)}>Delete</button>
                                            </div>
                                        </td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan="12" className="text-center">No data available in table</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <button className="btn btn-add text-white">Export to Excel</button>
                </div>
            </div>

            {/* ADD / EDIT MODAL */}
            {showModal && (
                <Modal
                    show={showModal}
                    onClose={handleCloseModal}
                    title={editingId !== null ? "Edit Assignment" : "Add Assignment"}
                    size="lg"
                >
                    {ModalForm}
                </Modal>
            )}
        </div>
    );
};

export default Assignments;